import { Switch } from "antd";
import { debounce } from "debounce";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { FILTER_ID } from ".";
import { selectOneSetting } from "../../../util/store/selectors";
import { IUnitOverview } from "../../../util/store/site/constants";
import { getStore, useSelector } from "../../../util/store/store";
import { SiteOverviewSetting } from "../../../util/varibles/userSetting";
import { loginActions } from "../../LoginPage/reducer";
import { callEventSiteOverview, useSiteOverview } from "../SiteOverviewContext";
import styles from './style.module.scss';

const SiteUnitProperties = () => {
    const [value, setValue] = useState<undefined | { [id: string]: (data: IUnitOverview) => boolean }>(undefined);
    const defaultFilter: boolean = useSelector(selectOneSetting(SiteOverviewSetting.UNITS_ACTIVE_UNIT_FILTER));
    const [call] = useSiteOverview(state => state.unitsFilter[FILTER_ID.SITE_UNIT_PROPERTIES]);
    const dispatch = useDispatch();

    const filter: { [id: string]: (data: IUnitOverview) => boolean } = useMemo(() => ({
        1: data => (data.starvings || []).length > 0,
        2: data => data.fish_amount > 0,
        3: data => {
            const { id } = data.site;
            const amount = getStore().site.overview.amount;
            return !amount[id];
        }
    }), []);

    const { addUnitsFilter, removeUnitsFilter } = callEventSiteOverview();

    const timeout = useRef(debounce((currentValue: typeof value = {}) => {
        if (Object.keys(currentValue).length === 0) {
            removeUnitsFilter(FILTER_ID.SITE_UNIT_PROPERTIES);
        } else {
            addUnitsFilter({ [FILTER_ID.SITE_UNIT_PROPERTIES]: data => Object.keys(currentValue).every(key => currentValue[key](data)) })
        }
        dispatch(loginActions.updateUserSetting([{ [SiteOverviewSetting.UNITS_ACTIVE_UNIT_FILTER]: !!currentValue[2] }]))
    }, 350));

    useEffect(() => {
        if (call === undefined) {
            setValue({});
        }
    }, [call]);

    useEffect(() => timeout.current(value), [value]);

    const handleChange = (checked: boolean, id: number) => {
        if (checked) {
            setValue(prev => ({ ...prev || {}, [id]: filter[id] }))
        } else {
            setValue(prev => {
                const { [id]: _, ...args } = prev || {};
                return args
            })
        }
    }

    useEffect(() => {
        if (value === undefined && defaultFilter) {
            setValue(prev => ({ ...prev || {}, 2: filter["2"] }))
        }
    }, [value, defaultFilter, filter])

    return <>
        <div data-lev='title'>
            Site, unit properties
        </div>
        <div>
            {/* <div className={styles.properties}>
                <Switch checked={!!value[1]} onChange={checked => handleChange(checked, 1)} />
            </div> */}
            <div className={styles.properties}>
                <div>Only active unit</div>
                <Switch checked={!!value?.[2]} onChange={checked => handleChange(checked, 2)} />
            </div>
            {/* <div className={styles.properties}>
                <div>Only empty site</div>
                <Switch
                    checked={!!value[3]}
                    onChange={checked => handleChange(checked, 3)}
                />
            </div> */}
        </div>
    </>
}

export default SiteUnitProperties;